export default {
  columns: 'Spalten',
  hasTotal: 'Summe',
  addColumn: 'Spalte hinzufügen',
  unknownAttribute: 'Gelöschtes Attribut',
};
